import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getGiftByIdSagaAction, removeGiftSagaAction, getGiftsSagaAction } from "../../redux/sagaActions";

const GiftsList = () => {
    const dispatch = useDispatch();

    const gifts = useSelector(state => state.gifts);
    const currentEstablishment = useSelector(state => state.currentEstablishment);

    // Получение списка бонусов
    useEffect(() => {
        if (!currentEstablishment) return;

        dispatch(getGiftsSagaAction());
    }, [currentEstablishment]);

    return (
        <div className="settings">
            {
                gifts.map(elem => {
                    return (
                        <div className="setting" key={ elem.id }>
                            <div className="controls">
                                <i className="control control--edit" onClick={ () => {
                                    dispatch(getGiftByIdSagaAction({ id: elem.id }));
                                } }/>
                                {/*<i className="control control--move" />*/}
                                <i className="control control--remove" onClick={ () => {
                                    if (window.confirm('Вы действительно хотите удалить этот бонус?')) {
                                        dispatch(removeGiftSagaAction({ id: elem.id }));
                                    }
                                } }/>
                            </div>
                            <div className="setting__caption">{ elem.name }</div>
                        </div>
                    );
                })
            }
        </div>
    );
};

export default GiftsList;